import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import standingsDatasource from '../../core/datasources/standings';
import { getTeamSummaryMatchupState } from './store/selectors/getTeamSummaryMatchUpState';
import teamSummaryMatchup from './store/reducers/teamSummaryMatchup';
import teamSummaryMatchupDataRequestAction from './store/actions/teamSummaryMatchupDataRequestAction';
import TeamSummaryMatchup from './TeamSummaryMatchup';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import gameOver from '@gameday/components/GameOver/store/reducers/gameOver';
import ruleSettingsDatasource from '@gameday/core/datasources/ruleSettings';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import { getDeviceInteraction } from '@gameday/utils/selectors/getDeviceInteraction';

const { SINGLENARROW } = liveViewsTypes;

initContainerData.register({
    datasources: {
        standings: standingsDatasource,
        ruleSettings: ruleSettingsDatasource,
        schedule: scheduleDataSource
    },
    reducers: {
        teamSummaryMatchup,
        gameOver
    }
});

const fetchData = () => {
    return teamSummaryMatchupDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const TeamSummaryMatchupDataContainer = ({
    displayRecords,
    displayStandings,
    hideTeamNames,
    useTri = false,
    componentName,
    ...otherProps
}) => {
    const scoresState = useSelector(getTeamSummaryMatchupState);
    const { deviceInteraction } = useSelector(getDeviceInteraction);
    const {
        away,
        home,
        abstractGameState,
        scores,
        standings,
        isLoading,
        currentInning,
        scheduledInnings,
        isPreGameDelay,
        isTBD,
        isWarmup,
        isSuspended,
        isInGameDelay,
        isInstantReplay,
        isManagerChallenge,
        isUmpireReview,
        isPostponed,
        isCancelled,
        isSuspendedResumptionOnDate,
        inningState,
        datetime,
        tz,
        tiebreakerScenario,
        isStickyScore,
        statusCode
    } = scoresState;

    return (
        <ErrorBoundaryWrapper componentName='TeamSummaryMatchup component' horizontal={otherProps?.$viewType !== SINGLENARROW} width={32} paddingOverride='15px' marginOverride='0'>
            <TeamSummaryMatchup
                awayWins={away?.record?.wins}
                awayLosses={away?.record?.losses}
                homeWins={home?.record?.wins}
                homeLosses={home?.record?.losses}
                awayRuns={scores?.away}
                homeRuns={scores?.home}
                homeTeamId={home?.id}
                awayTeamId={away?.id}
                gameStatus={ abstractGameState }
                awayName={ useTri ? away?.abbreviation : away?.teamName}
                homeName={ useTri ? home?.abbreviation : home?.teamName}
                awayStandingsText={standings?.away}
                homeStandingsText={standings?.home}
                isLoading={isLoading}
                currentInning={ currentInning }
                scheduledInnings={ scheduledInnings }
                isPreGameDelay={isPreGameDelay}
                isTBD={isTBD}
                isWarmup={isWarmup}
                isSuspended={isSuspended}
                isInGameDelay={isInGameDelay}
                isInstantReplay={isInstantReplay}
                isManagerChallenge={isManagerChallenge}
                isUmpireReview={isUmpireReview}
                isPostponed={isPostponed}
                isCancelled={isCancelled}
                isSuspendedResumptionOnDate={isSuspendedResumptionOnDate}
                inningState={inningState}
                datetime={datetime}
                tz={tz}
                displayRecords={displayRecords}
                displayStandings={ displayStandings }
                hideTeamNames={ hideTeamNames }
                tiebreakerScenario={tiebreakerScenario}
                isStickyScore={isStickyScore}
                deviceInteraction={deviceInteraction}
                componentName={componentName}
                statusCode={statusCode}
                {...otherProps}
                awayAllStarStatus={away?.allStarStatus}
                homeAllStarStatus={home?.allStarStatus}
            />
        </ErrorBoundaryWrapper>
    );
};

TeamSummaryMatchupDataContainer.propTypes = {
    useTri: PropTypes.bool,
    displayRecords: PropTypes.bool,
    displayStandings: PropTypes.bool,
    hideTeamNames: PropTypes.bool,
    imgWidth: PropTypes.string,
    isStickyScore: PropTypes.bool,
    componentName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
};

export default TeamSummaryMatchupDataContainer;
export { fetchData, routes };
